
import { Vue, Component } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import { set } from "lodash";
import axios from "axios";
@Component
export default class Home extends Vue {
  dataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 15,
    },
    className: "LeadClass",
  });

  headers =[
      {
          "text": "ID",
          "value": "id",
          "sortable": true
      },
      {
          "text": "Дата создания",
          "value": "createDate",
          "sortable": true
      },
      {
          "text": "Подпись",
          "value": "caption",
          "sortable": true
      },
      {
          "text": "По умолчанию",
          "value": "isDefault",
      },
      {
          "text": "Статус",
          "value": "instanceStateId",
          "sortable": false
      }
  ]


  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Классы лида",
        disabled: true,
      },
    ];
  }



  async setDefault(item: any) {
    await axios
      .put(`/manage/leadclass/set-default/${item.id}/`)
    await this.dataSource.get();
  }
}
